export default __webpack_public_path__ + "static/happy-people-ceaa8b5b10ff9cb657ca22aee0947c06.svg";